import React from 'react';
import { Grid, Slider, Typography } from '@material-ui/core';
import { useStatsCardsStyles } from './statsCard.style';
import { useState } from 'react';

const StatsCard = ({ Icon, title, subtitle, name, onChangeStat }) => {
  const classes = useStatsCardsStyles();
  const [sliderValue, setSliderValue] = useState(70);

  const onChangeSlider = (_e, value) => {
    setSliderValue(value);
  };

  const onSetSliderValue = (_e, value) => {
    onChangeStat(name, value);
  };

  return (
    <Grid container>
      <Grid item xs={12} classes={{ root: classes.container }}>
        <Icon classes={{ root: classes.icon }} />
        <div className={classes.contentContainer}>
          <Typography classes={{ root: classes.title }}>{title}</Typography>
          <Typography classes={{ root: classes.subtitle }}>
            {subtitle}
          </Typography>
          <div className={classes.sliderContainer}>
            <Slider
              name={name}
              max={100}
              min={0}
              defaultValue={70}
              onChange={onChangeSlider}
              onChangeCommitted={onSetSliderValue}
              classes={{
                rail: classes.sliderRail,
                track: classes.sliderRail,
                thumb: classes.sliderThumb,
              }}
            />
            <Typography classes={{ root: classes.sliderValue }}>
              {sliderValue}%
            </Typography>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default StatsCard;
